module.exports = __webpack_public_path__ + "img/thumbnail_Saiga_j_albino.7ab7f93a.png";